export const questionnaire = {
  "questionnaire_title": "الاستبيانات",
  "questionnaire_point": "نقاط",
  "questionnaire_questionnaire": "الأسئلة",
  "questionnaire_minutes": "دقائق",
  "questionnaire_continue": "استمر",
  "questionnaire_start": "ابدأ",
  "questionnaire_identity_conflict": "هذه القيمة مستخدمة بالفعل من قبل مشارك آخر. لم يتم حفظ إجابتك.",
  "questionnaire_identity_unknown_external_id": "رقم الملف غير معروف — تحقق من الرقم الذي سلمه لك الفريق. لم يتم حفظ إجابتك."
}
